export function detectPlatformsFromLinks(links) {
  // asume shape links: { instagram?: string, tiktok?: string, facebook?: string, ... }
  const has = (v) => !!(v && String(v).trim().length > 0);
  
  return {
    instagram: has(links?.instagramProfile) || has(links?.instagram) || /instagram\.com/i.test(links?.instagramProfile ?? ""),
    tiktok:    has(links?.tiktokProfile) || has(links?.tiktok) || /tiktok\.com/i.test(links?.tiktokProfile ?? ""),
    facebook:  has(links?.facebookProfile) || has(links?.facebook) || /facebook\.com/i.test(links?.facebookProfile ?? ""),
    linkedin:  has(links?.linkedinProfile) || has(links?.linkedin) || /linkedin\.com/i.test(links?.linkedinProfile ?? ""),
  };
}